import React from 'react';
import {Check} from 'lucide-react';

interface StepsProgressProps {
    currentStep: number;
}

const steps = ['Basics', 'Import chat', 'Person', 'Avatar & voice'];

const StepsProgress = ({currentStep}: StepsProgressProps) => {
    return (
        <ol className="StepsProgress" aria-label={`Step ${currentStep} of ${steps.length}`}>
            {steps.map((label, idx) => {
                const step = idx + 1;
                const state = currentStep > step ? 'active' : currentStep === step ? 'current' : '';
                return (
                    <React.Fragment key={label}>
                        <li className={`StepsProgress__step ${state}`}
                            aria-current={currentStep === step ? 'step' : undefined}>
                            <span className="StepsProgress__circle">
                                {currentStep > step ? <Check size={14} strokeWidth={3}/> : step}
                            </span>
                            <span className="StepsProgress__label">{label}</span>
                        </li>
                        {step < steps.length && <li aria-hidden className={`hr ${currentStep > step ? 'activeHR' : ''}`}/>}
                    </React.Fragment>
                );
            })}
        </ol>
    );
};

export default StepsProgress;
